<template>
  <PlanList></PlanList>
</template>

<script>
  import PlanList from '@/page/modules/plan/list'
  export default {
    components: { PlanList },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
  .online_bg { margin-top: 0; }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/plan/list.vue